import React, { useState } from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import './confirm-coverage-area.scss'
import Button from '../../../shared/components/atoms/button/button'

const ConfirmCoverageArea = ({ content, openModal }) => {
  const [departamento, setDepartamento] = useState()

  const pushDataLayerError = ciudad => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'ga_event',
      category: 'V-Confident :: Muestra Gratis',
      action:
        'Confirmación cobertura :: No estás dentro de la zona de cobertura. Selecciona otra dirección para poder enviarte tu muestra.',
      label: `${departamento} :: ${ciudad}`,
      value: '',
    })
  }

  const dataLayerCoverage = (coverage, deparmentName, cityName) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_ZonaCobertura_VConfident',
      category: 'v-confident',
      action: 'click',
      label: coverage,
      departamento_cobertura: deparmentName,
      ciudad_cobertura: cityName,
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const dataLayerPedirMuestra = () => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Muestra_VConfident',
      category: 'v-confident',
      action: 'click',
      label: 'Pedir muestra',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  return (
    <div className="f-coverage-area">
      <GatsbyImage
        className="f-coverage-area__banner"
        objectFit="cover"
        alt={content.bannerPrincipal.titulo}
        image={withArtDirection(getImage(content.bannerPrincipal.banner[0]), [
          {
            media: '(max-width: 960px)',
            image: getImage(content.bannerPrincipal.banner[1]),
          },
        ])}
      />
      <div className="f-coverage-content">
        <h1 className="f-coverage-area__title">{documentToReactComponents(
          JSON.parse(content.tituloEnriquecido.raw)
        )}</h1>

        <div className="f-coverage-area__description">
          {documentToReactComponents(
            JSON.parse(content.informacionPrincipal.raw)
          )}
        </div>
        <Button
          className="f-coverage-area__button"
          text="Quiero mi Kit gratis"
          color="pink"
          action={() => {
            dataLayerPedirMuestra()
            openModal()
          }}
        />
        { ['es-CO','es-EC','es-DO'].includes(process.env.LOCALE) && (
          <div className="f-coverage-area__download">
            <p>Conoce aqui nuestras <a href={`/v-confident/Cobertura_VConfident_${process.env.LOCALE}.pdf`} target='_blank'>zonas de cobertura</a></p>
          </div>
        )}
      </div>
    </div>
  )
}

export default ConfirmCoverageArea
